import React, { useState } from 'react';
import { demoSources } from '../../utils/demoMedia';

/**
 * A still picture of an exercise demo, for lists that show many exercises at once.
 *
 * It shows the small poster made beside each demo video (about 50 kB) and never the
 * animation itself (about 3 MB each): a screen that put the GIF in every row asked the
 * browser for hundreds of megabytes on opening. A demo that is not in storage, or whose
 * poster does not load, falls back to its GIF; if that fails too, `fallback` is shown.
 */
const Still = ({ sources, alt = '', style, className, onClick, fallback = null }) => {
  const [posterFailed, setPosterFailed] = useState(false);
  const [gifFailed, setGifFailed] = useState(false);
  const usePoster = sources.poster && !posterFailed;
  const source = usePoster ? sources.poster : sources.gif;
  if (!source || gifFailed) return fallback;
  return (
    <img
      src={source}
      alt={alt}
      loading="lazy"
      decoding="async"
      style={style}
      className={className}
      onClick={onClick}
      onError={() => {
        if (usePoster) setPosterFailed(true);
        else setGifFailed(true);
      }}
    />
  );
};

const ExerciseStill = ({ gifUrl, ...props }) => (
  <Still key={gifUrl || ''} sources={demoSources(gifUrl)} {...props} />
);

// What to open when somebody asks to see the demo move: the video if there is one.
export const demoToOpen = (gifUrl) => {
  const { video, gif } = demoSources(gifUrl);
  return video || gif;
};

export default ExerciseStill;
